import { call, put, takeEvery, all, fork } from "redux-saga/effects";

// Crypto Redux States
import {
  GET_ONCALLS,
  POST_ONCALLS,
} from "./actionTypes";

//Include Both Helper File with needed methods

import {
  getOncallsSuccess,
  getOncallsFail,
  postOncallsFail,
} from "./actions";

import {
  getServices,
  postAddService
} from "../../helpers/fakebackend_helper";

function* onGetOncalls() {
  try {
    const response = yield call(getServices);
    yield put(getOncallsSuccess(response));
  } catch (error) {
    yield put(getOncallsFail(error));
  }
}

function* onPostAddOncalls({ payload: { oncalls } }) {
  const response = yield call(postAddService, {
    oncalls: oncalls
  })
}

function* oncallsSaga() {
  yield takeEvery(GET_ONCALLS, onGetOncalls);
  yield takeEvery(POST_ONCALLS, onPostAddOncalls);
}

export default oncallsSaga;
